<template>
    <div class="countdown">
      <span class="time">{{ days }}</span>天
      <span class="time">{{ hours }}</span>小时
      <span class="time">{{ minutes }}</span>分钟
      <span class="time">{{ seconds }}</span>秒
    </div>
  </template>
  <script>
  export default {
    props: {
      second: {
        type: Number,
        required: true,
      },
    },
    data() {
      return {
        remainingSeconds: 0,
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
        countdownInterval: null,
      };
    },
    mounted() {
      this.startCountdown();
    },
    beforeUnmount() {
      this.stopCountdown();
    },
    methods: {
      startCountdown() {
        this.remainingSeconds = this.second;
        this.updateTime();
  
        this.countdownInterval = setInterval(() => {
          if (this.remainingSeconds > 0) {
            this.remainingSeconds--;
            this.updateTime();
          } else {
            this.stopCountdown();
            //倒计时结束触发的时间
            this.$emit('countdown-ended');
          }
        }, 1000);
      },
      stopCountdown() {
        clearInterval(this.countdownInterval);
      },
      updateTime() {
        this.days = Math.floor(this.remainingSeconds / (24 * 60 * 60));
        let remainingSeconds = this.remainingSeconds % (24 * 60 * 60);
        this.hours = Math.floor(remainingSeconds / (60 * 60));
        remainingSeconds %= 60 * 60;
        this.minutes = Math.floor(remainingSeconds / 60);
        this.seconds = remainingSeconds % 60;
      },
    },
  };
  </script>
  
  <style>
  .countdown {
    font-size: 12px;
    padding: 0 0.2rem;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
  }  
  .time {
    font-weight: bold;
    color: #CE5F3A;
  }
  </style>
  